{
  "revision": "v01",
  "base": "art/blender/hero-r04.blend",
  "reference": "ConceptArt.png \u00b7 standing character lineup",
  "characters": [
    {
      "id": "dark",
      "name": "Dark",
      "description": "Charcoal coat \u00b7 silver warm-grey muzzle",
      "coat": "303234",
      "cream": "9A9C8B",
      "mask": "181B20",
      "crown": "34363A",
      "skin": "665D55",
      "muzzle": "B0AD98",
      "iris": "9C965F",
      "bodyWidth": 0.96,
      "height": 1.035,
      "crownHeight": 0.64,
      "smile": 0.87,
      "headTilt": -3
    },
    {
      "id": "golden",
      "name": "Golden",
      "description": "Ochre gold \u00b7 cream cheeks \u00b7 amber eyes",
      "coat": "B47D31",
      "cream": "EAD19B",
      "mask": "654521",
      "crown": "BC893D",
      "skin": "9C713F",
      "muzzle": "EED5A3",
      "iris": "BE8B43",
      "bodyWidth": 1.025,
      "height": 1.0,
      "crownHeight": 0.91,
      "smile": 1.0,
      "headTilt": 3
    },
    {
      "id": "snow",
      "name": "Snow",
      "description": "Pearl-grey coat \u00b7 ivory chest \u00b7 ash mask",
      "coat": "BCC4C0",
      "cream": "EEEDE1",
      "mask": "495550",
      "crown": "D0D4CA",
      "skin": "8A7B71",
      "muzzle": "E0DFCF",
      "iris": "A5AB83",
      "bodyWidth": 1.02,
      "height": 1.015,
      "crownHeight": 0.76,
      "smile": 0.88,
      "headTilt": -2
    },
    {
      "id": "red-faced",
      "name": "Red-faced",
      "description": "Chestnut-black coat \u00b7 warm coral face",
      "coat": "503830",
      "cream": "CFC7AD",
      "mask": "3A2B28",
      "face": "BF5C49",
      "crown": "473229",
      "skin": "82675C",
      "muzzle": "D8CBB5",
      "iris": "A29A60",
      "bodyWidth": 0.96,
      "height": 1.035,
      "crownHeight": 0.57,
      "smile": 0.92,
      "headTilt": 4
    },
    {
      "id": "baby",
      "name": "Baby",
      "description": "Little explorer \u00b7 soft walnut \u00b7 rounded proportions",
      "coat": "927052",
      "cream": "DECBA9",
      "mask": "534139",
      "crown": "967252",
      "skin": "AD8B72",
      "muzzle": "EAD2B0",
      "iris": "AC8551",
      "bodyWidth": 0.72,
      "height": 0.665,
      "crownHeight": 0.4,
      "smile": 0.78,
      "headTilt": -5
    }
  ]
}
